module.exports = __webpack_public_path__ + "media/fonts/Oricons-3717723033c1a1355b7f8dd6bee83d59.woff2";